import { AbsoluteCenter, Box, Flex, Image, Text } from '@chakra-ui/react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../constant';
import usePwaDetected from '../../hook/usePwaDetected';

const Footer = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`footer.${key}`);

  const currentLng = i18next.language;
  const isTw = currentLng === 'tw';

  const isPwa = usePwaDetected();
  const FOOTER_LIST = [
    {
      image: `${COMMON_WEB_PATH}/blue-layout/footer${i18next.language === 'tw' ? '' : `/${i18next.language}`}/footer_transaction.png`,
      link: '/profile/transaction',
      auth: true,
      font: 'history',
      afterStyle: {
        position: 'absolute',
        top: 0,
        left: isTw ? 0 : '-23%',
        w: isTw ? '112%' : '135%',
        h: '100%'
      }
    },
    {
      image: `${COMMON_WEB_PATH}/blue-layout/footer${i18next.language === 'tw' ? '' : `/${i18next.language}`}/footer_betRecord.png`,
      link: 'profile/betRecord',
      auth: true,
      font: 'betrecord',
      afterStyle: {
        position: 'absolute',
        top: 0,
        right: 0,
        w: '117%',
        h: '100%'
      }
    },
    {
      image: `${COMMON_WEB_PATH}/blue-layout/footer${i18next.language === 'tw' ? '' : `/${i18next.language}`}/footer_search.png`,
      link: 'search',
      auth: true,
      font: 'search',
      afterStyle: {
        position: 'absolute',
        top: 0,
        right: 0,
        w: '108%',
        h: '100%'
      }
    },
    {
      image: `${COMMON_WEB_PATH}/blue-layout/footer${i18next.language === 'tw' ? '' : `/${i18next.language}`}/footer_pwa.png`,
      link: '/profile/data',
      auth: true,
      hidden: !isPwa,
      font: 'MyFavorite',
      afterStyle: {
        position: 'absolute',
        top: 0,
        right: 0,
        w: '109%',
        h: '100%'
      }
    },
    {
      image: `${COMMON_WEB_PATH}/blue-layout/footer${i18next.language === 'tw' ? '' : `/${i18next.language}`}/footer_pwa.png`,
      link: 'app',
      hidden: isPwa,
      font: 'app',
      afterStyle: {
        position: 'absolute',
        top: 0,
        right: isTw ? 0 : '-18%',
        w: isTw ? '109%' : '127%',
        h: '100%'
      }
    }
  ];

  return (
    <Box as="footer" w="100%" position="fixed" bottom="0" left="0" zIndex={999}>
      <Box
        as="section"
        w="100%"
        h="60px"
        display="flex"
        position="relative"
        borderTopRadius={'common'}
        alignItems={`center`}
        justifyContent={`space-around`}
      >
        {FOOTER_LIST?.filter((item) => !item.hidden)?.map((footer, index) => {
          return (
            <Box
              as={NavLink}
              display={'flex'}
              h="100%"
              w="25%"
              key={index}
              to={footer.link}
              overflow="visible"
            >
              {({ isActive }) => {
                return (
                  <Flex
                    alignItems="center"
                    flexDirection={`column`}
                    justifyContent="center"
                    w="100%"
                    position="relative"
                    _after={{
                      content: "''",
                      bgImage: `url(${footer.image})`,
                      bgSize: '100% 100%',
                      position: 'absolute',
                      ...footer.afterStyle
                    }}
                  ></Flex>
                );
              }}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Footer;
